module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTcgMnY0aC0yYy0uNjkgMC0xIC44MS0xIDEuNVYxMGgzdjRoLTN2OGgtNHYtOEg3di00aDNWNmE0IDQgMCAwIDEgNC00aDN6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/facebook.svg
// module id = 541
// module chunks = 0